module.exports = __webpack_public_path__ + "static/media/cafe_fulltime.08dbc5bd.png";